import Joi from 'joi';

/**
 * Query schema for GET billing/integrity.
 * Optional from/to (ISO UTC). When both present, from must be strictly before to.
 * Omitted → service defaults to the previous full calendar month in UTC.
 */
export const billingIntegrityQuerySchema = () =>
  Joi.object({
    from: Joi.string().isoDate().optional(),
    to: Joi.string().isoDate().optional(),
  })
    .and('from', 'to')
    .custom((value, helpers) => {
      if (value.from && value.to && value.from >= value.to) {
        return helpers.error('any.invalid');
      }
      return value;
    }, 'from before to')
    .messages({
      'any.invalid': '"from" must be strictly before "to"',
    })
    .unknown(false);
